import { jsx as _jsx } from "react/jsx-runtime";
import { createRef, useEffect, useMemo, useRef, useState } from "react";
import { Menu } from "antd";
const BaseTableContextMenu = ({ contextMenuItems, onContextMenuSelect, visible, left, top }) => {
    const ref = useRef();
    const menuRef = createRef();
    const [menuHeight, setMenuHeight] = useState(0);
    useEffect(() => {
        if (ref.current) {
            setTimeout(() => {
                setMenuHeight(ref.current.offsetHeight);
            }, 1);
        }
    }, [ref, contextMenuItems === null || contextMenuItems === void 0 ? void 0 : contextMenuItems.length]);
    const position = useMemo(() => {
        if (!visible)
            return {};
        if (!ref.current)
            return {
                top: 0,
                left: 0
            };
        const _position = { top, left };
        const wrapper = ref.current.parentElement;
        if (!wrapper)
            return _position;
        const table = wrapper.querySelector(".BaseTable__table .BaseTable__body");
        const tableBounding = table.getBoundingClientRect();
        const tableBottom = ((tableBounding === null || tableBounding === void 0 ? void 0 : tableBounding.top) || 0) + ((tableBounding === null || tableBounding === void 0 ? void 0 : tableBounding.height) || 0);
        const contextMenuBottom = (top || 0) + menuHeight;
        if (contextMenuBottom > tableBottom)
            _position.transform = "translateY(-100%)";
        return _position;
    }, [top, left, ref, visible, menuHeight]);
    return (_jsx("div", { ref: ref, className: [
            "BaseTable__context-menu te-transition te-duration-100",
            "ant-dropdown-menu"
        ].join(" "), style: Object.assign({ visibility: menuHeight && visible ? "visible" : "hidden", opacity: menuHeight && visible ? 1 : 0 }, position), children: _jsx(Menu, { ref: menuRef, selectable: false, items: contextMenuItems, onClick: onContextMenuSelect }) }));
};
export default BaseTableContextMenu;
